export const defaults = {
  description: {
    maxLength: 150,
    minLength: 100,
  },
  title: {
    maxLength: 60,
    minLength: 50,
  },
}
